export enum ROUTES_E {
  HOME = "/",
  SIGN = "/login?signup",
  LOGIN = "/login",
  ACCOUNT = "/account/:user",
  MACHINES = "/machines",
  SPAREPARTS = "/spareparts",
  CLIENTS = "/clients",
  SETTINGS = "/settings",
  LOCATIONS = "/locations",
  MANAGMENT = "/managment",
  MESSENGER = "/messenger",
  NOTIFICATIONS = "/notifications",
  SCANREPORT = "/scanreport",
  PARAMS = "/user/:param",
  ERROR = "/error/:msg",
  INFO = "r/hint/text",

  TEST_CHART = "/test/chart",
}
